export const environment = {
    production: false,
    version: 'DEV'
};
